import { computed } from "vue";
import {} from "@/api/configTemplates";
export function useFiltering(allInstances) {
    const activeInstances = computed(() => {
        return allInstances.value.filter((item) => !item.hidden);
    });
    return {
        activeInstances,
    };
}
